module.exports = __webpack_public_path__ + "img/78.7.Chla.286fea8c.png";